<template>
    <div>
        <b-carousel
            id="carousel-1"
                v-model="slide"
                :interval="5000"
                controls
                indicators
                background="#ababab"
                img-width="1600"
                img-height="640"
                style="text-shadow: 1px 1px 2px #333;"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
            >
            
            <b-carousel-slide v-for="banner in banners" :key="banner.id_banner"
                :img-src="banner.foto"
            >
                <h1>{{ banner.titulo }}</h1>

                <p>{{ banner.descripcion }}</p>
            </b-carousel-slide>
        </b-carousel>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import { getBannersAction } from '../modules/common/actions/get-banners.action';

export default {
    name: 'Carrusel',
    props: {
    },
    data() {
        return {
            slide: 0,
            sliding: null,
            banners: []
        }
    },
    async created() {
        var formData = new FormData();
        formData.append("accion", "traerBanners");
        formData.append("url", this.urlAdm);
        
        const data = await getBannersAction(formData)

        this.banners = data.banners
    },
    methods: {
      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      }
    },
    computed: {
        url() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                return this.urlSandbox
            } else {
                return this.urlProd
            }
        },
         urlAdm() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                return this.urlAdminS
            } else {
                return this.urlAdmin
            }
        },
        ...mapState(['urlProd']),
        ...mapState(['urlSandbox']),
        ...mapState(['urlAdmin']),
        ...mapState(['urlAdminS'])
    }
}
</script>

<style scoped>

</style>